import React from 'react';
import Box from '@mui/material/Box';
import SelectIcon from './icon-button';

interface BaseLabelProps {
	id: string;
	label: React.ReactNode;
	modal?: boolean;
	isMobile?: boolean;
	onIconClick: () => void;
}

export const BaseLabel: React.FC<BaseLabelProps> = ({ id, label, modal, isMobile, onIconClick }) => {
	if (modal && isMobile) {
		return (
			<Box
				sx={{
					display: 'flex',
					flexDirection: 'row',
					alignItems: 'center',
					width: '100%',
					backgroundColor: 'background.paper',
				}}
			>
				{label}
				<SelectIcon id={id} onClick={onIconClick} isMobile={isMobile} />
			</Box>
		);
	}
	return <>{label}</>;
};
